module.exports = __webpack_public_path__ + "img/左侧背景@2x.56b92034.png";